// noinspection JSUnresolvedReference,ES6MissingAwait

import moment from "moment";
import { message } from "antd";

import { downloadText, uuid } from "../../util";

// noinspection JSFileReferences
import Dexie from "dexie/dist/dexie.js";

const WATCH_DURATION = 5000;

export const DirectoryFileDatabase = function (dbName) {
  const instance = new Dexie(dbName);
  instance.version(2).stores({
    files:
      "++id,name,size,type,status,lastModified,lastModifiedDate,relativePath",
  });

  return instance;
};

let fileLogMap = {};
let loadingMap = {};
let __total = 0;

export const fileLog = async (id, fileHandler, message) => {
  if (!fileLogMap[String(id)]) {
    fileLogMap[String(id)] = [];
  }

  fileLogMap[String(id)].push(
    `${moment().format("YYYY-MM-DD HH:mm:ss")} ${message}`
  );
};

export const saveFileLog = async (id) => {
  if (fileLogMap[String(id)] && fileLogMap[String(id)] instanceof Array) {
    downloadText(
      fileLogMap[String(id)].join("\n"),
      `修图助手日志_${moment().format("YYYYMMDD_HHmmss")}`
    );
  }
};

class Watcher {
  timer = 0;
  fileHandler = null;
  indexedDB = null;
  dbName = "";
  emitter = {};

  constructor(options) {
    const { handler, dbName } = options;
    this.fileHandler = handler;
    this.dbName = dbName;
    this.indexedDB = new DirectoryFileDatabase(dbName);

    this.clearAllTempData();
  }

  async clearAllTempData() {
    await this.indexedDB.files.where("status").equals(0).delete();
  }

  start() {
    this.setLoading(false);
    this.next();
  }

  getLoading = () => {
    return loadingMap[this.dbName];
  };

  setLoading = (flag) => {
    loadingMap[this.dbName] = flag;
  };

  next = () => {
    let _this = this;
    this.timer = window.setInterval(() => {
      console.log(`轮询当前状态 ${_this.getLoading()}`);
      fileLog(
        _this.dbName,
        _this.fileHandler,
        `轮询状态，当前上传状态 ${_this.getLoading()} `
      );
      if (!_this.getLoading()) {
        _this.cronHandler();
      }
    }, WATCH_DURATION);
  };

  stop() {
    window.clearInterval(this.timer);
  }

  async clear() {
    if (this.indexedDB) {
      return await this.indexedDB.files.clear();
    }
  }

  async update(where, updateData) {
    const exist = await this.indexedDB.files.where(where).first();
    if (exist) {
      await this.indexedDB.files.update(exist.id, updateData);
    }
  }

  on(eventName, handler) {
    let events = this.emitter[eventName];
    if (!(events instanceof Array)) {
      events = [];
    }
    events.push(handler);

    this.emitter[eventName] = events;
  }

  off(eventName, handler) {
    let events = this.emitter[eventName];
    if (events instanceof Array) {
      events = events.filter((event) => event !== handler);

      this.emitter[eventName] = events;
    }
  }

  async dispatch(eventName, options) {
    let events = this.emitter[eventName];
    if (events instanceof Array) {
      // events.forEach(handler=>{
      //   handler(options);
      // });
      for (let i = 0; i < events.length; i++) {
        if (events[i] && typeof events[i] == "function") {
          await events[i](options);
        }
      }
    }
  }

  isSame(oldFile, newFile) {
    let same = true;
    if (Number(oldFile.lastModifiedDate) < Number(newFile.lastModifiedDate)) {
      same = false;
    } else if (Number(oldFile.size) !== Number(newFile.size)) {
      same = false;
    }

    return same;
  }

  async fileStatus(file) {
    const exist = await this.indexedDB.files
      .where({
        name: file.name,
        relativePath: file.relativePath,
      })
      .first();

    if (exist) {
      // 判断是否有更新
      const same = this.isSame(exist, file);

      if (!same) {
        // 有更新哦
        await this.indexedDB.files.update(exist.id, {
          status: 0,
          size: file.size,
          lastModified: file.lastModified,
          lastModifiedDate: moment(file.lastModifiedDate).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
        });
        await fileLog(
          this.dbName,
          this.fileHandler,
          `文件有更新 ${file.relativePath} ${file.name}`
        );
        await fileLog(
          this.dbName,
          this.fileHandler,
          `发布更新文件事件：${file.relativePath} ${file.name}`
        );
        this.dispatch(EVENT_FILE_MODIFY, {
          file,
        });
      } else {
        await fileLog(
          this.dbName,
          this.fileHandler,
          `文件一致不更新 ${file.relativePath} ${file.name}`
        );
      }
    } else {
      // 新增文件
      await this.indexedDB.files.add({
        name: file.name,
        relativePath: file.relativePath,
        size: file.size,
        type: file.type,
        status: 0,
        lastModify: file.lastModified,
        lastModifiedDate: moment(file.lastModifiedDate).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      });
      await fileLog(
        this.dbName,
        this.fileHandler,
        `文件不存在 新建数据 ${file.relativePath} ${file.name}`
      );
      await fileLog(
        this.dbName,
        this.fileHandler,
        `发布新增文件事件：${file.relativePath} ${file.name}`
      );
      this.dispatch(EVENT_FILE_ADD, {
        file,
      });
    }
  }

  async filePatch(rootHandler, rootName) {
    await fileLog(this.fileHandler, `检测文件属性`);
    __total++;
    if (rootHandler.kind === "file") {
      const file = await rootHandler.getFile();
      file.relativePath = rootName;
      console.log(`单个文件`, rootName, file.name, __total);
      // await fileLog(this.dbName, this.fileHandler, `文件属性：${file.relativePath} ${file.name}`);
      await this.fileStatus(file);
    } else if (rootHandler.kind === "directory") {
      const currentDirectoryName = rootHandler.name;
      // await fileLog(this.dbName, this.fileHandler, `文件夹属性：${currentDirectoryName}`);
      console.log(`文件夹`, currentDirectoryName, __total);
      for await (const [, handle] of rootHandler.entries()) {
        await this.filePatch(
          handle,
          (rootName ? `${rootName}/` : "") + currentDirectoryName
        );
      }
    }
  }

  async cronHandler() {
    try {
      this.setLoading(true);
      console.log(`设置正在处理中`);
      if (this.fileHandler) {
        const entries = this.fileHandler.entries();
        __total = 0;
        for await (const [, handle] of entries) {
          try {
            await this.filePatch(handle, "");
          } catch (e) {
            console.error(`非预期的错误`, e);
            // fileLog(this.dbName, this.fileHandler, `单个文件处理错误 ${e.toString()}`);
          }
        }
        // let done = false;
        // while(!done) {
        //   total++;
        //   const next = await entries.next();
        //   done = next.done;
        //   console.log(done);
        //   if(next.value) {
        //     const [name, handle] = next.value;
        //     console.log(`单个文件`, total, name);
        //     if(total == 108) {
        //       debugger;
        //     }
        //     await this.filePatch(handle, '');
        //   }
        // }

        console.log(`entries 遍历结束`);
      }
      this.setLoading(false);
      console.log(`设置为待处理（try）`);
    } catch (e) {
      console.error(`fileHandler entries error`, e);
      await fileLog(
        this.dbName,
        this.fileHandler,
        `文件夹遍历错误 ${e.toString()}`
      );
    } finally {
      this.setLoading(false);
      console.log(`设置为待处理（finally）`);
    }
  }
}

const manager = {
  __instances: {},

  getInstance: (id) => {
    return manager.__instances[id];
  },
  clear: async (id, fileHandler) => {
    let instance = manager.getInstance(id);
    if (!instance) {
      instance = manager.create(id, {
        handler: fileHandler,
        dbName: id,
      });
    }
    await instance.clear();

    await fileLog(id, fileHandler, `清空数据库 ${id}`);
  },
  create: (id, options) => {
    const instance = new Watcher(options);
    manager.__instances[id] = instance;
    return instance;
  },
  updateLocalData: async (id, options) => {
    const { where, updateData } = options;
    const instance = manager.getInstance(id);
    if (instance) {
      await instance.update(where, updateData);
    }
  },
  start: (id, fileHandler) => {
    const target = manager.getInstance(id);
    if (target) {
      target.start();
      return target;
    } else {
      const instance = manager.create(id, {
        handler: fileHandler,
        dbName: id,
      });
      instance.start();
      return instance;
    }
  },
  stop: (id) => {
    const target = manager.getInstance(id);

    if (target) {
      target.stop();
    }

    return target;
  },
  checkConfig: async (config) => {
    const { fileHandler } = config;
    let result = {
      success: false,
      message: "未知",
    };
    if (fileHandler) {
      const permissionOptions = {
        mode: "readwrite",
      };
      if (
        (await fileHandler.queryPermission(permissionOptions)) === "granted"
      ) {
        result.success = true;
      } else {
        // Request permission to the file, if the user grants permission, return true.
        if (
          (await fileHandler.requestPermission(permissionOptions)) === "granted"
        ) {
          result.success = true;
        } else {
          result.success = false;
          result.message = "请先授权允许修改此目录";
        }
      }
    } else {
      result.message = "请先选择待操作目录";
    }

    if (result.success) {
      // 检测文件夹是否存在
      try {
        const tempHandler = await fileHandler.getDirectoryHandle(
          `.tmp_${uuid()}`,
          {
            create: true,
          }
        );

        await tempHandler.remove();
      } catch (e) {
        result.success = false;
        result.message = `操作目录失败，请检查`;
      }
    }

    return result;
  },
};

export const EVENT_FILE_ADD = `watcher-file-add`;
export const EVENT_FILE_MODIFY = `watcher-file-modify`;

export const validateENV = async () => {
  // 检测当前是否为 https 环境
  if (window.location.protocol !== "https:") {
    message.error("请使用HTTPS访问");
    return false;
  }

  // 检测是否为Chrome
  if (window.navigator.userAgent.toLowerCase().indexOf("chrome") < -1) {
    message.error("此功能要求使用Chrome浏览器，请更换");
    return false;
  }

  return true;
};

export default manager;



// WEBPACK FOOTER //
// ./src/components/FileViewerV2/FileWatcher.js